<template>
    <div class="table">
        <div class="container">
            <el-tabs type="border-card" v-model="currentTab">
                <el-tab-pane :label="$t('ssrManage.baseInfoPane')" name="baseInfoPane">
                    <div style="padding-bottom: 15px;">
                        <el-button v-if="ssr.canAccept" type="primary" @click="accept(true)">{{$t('ssrManage.biding')}}</el-button>
                        <el-button v-if="ssr.canAccept" type="primary" @click="accept(false)">{{$t('ssrManage.refuse')}}</el-button>
                    </div>
                    <ssr-manage-add v-model="ssr"/>
                </el-tab-pane>
                <el-tab-pane :name="'round'+round.roundNumber" v-for="round in ssr.ssrRounds" v-if="round.ssrRoundSuppliers[0].status != null" :label="`Proposal ${toRomanNum(round.roundNumber)}`">
                    <proposal-pane :showCopyToNewRound="showCopyToNewRound(round)" @copyToNewRound="copyToNewRound(round)" :round.sync="round" :ssr="ssr"/>
                </el-tab-pane>
                <el-tab-pane :label="$t('ssrManage.spmCorePane')" name="spmCorePane">
                    <spm-core-pane :can-edit="false" :rounds="ssr.ssrRounds" :ssr="ssr"/>
                </el-tab-pane>
                <el-tab-pane label="Recommendation" name="Recommendation" v-if="isRecommendation">
                    <div style="text-align: center;">
                        <img src="@/assets/img/u15566.png" alt="">
                        <div>Congratulations，you did it！</div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import ssrManageAdd from "@/components/page/ssr-manage/ssr-manage-add";
    import proposalPane from "@/components/page/ssr-manage/proposal-pane";
    import spmCorePane from "@/components/page/ssr-manage/spm-core-pane";
    import commonFun from "@/utils/commonFun";
    import {ssr} from "@/store/modules/ssr/getters";

    export default {
        name: 'ssr-detail-ss',
        extends: commonMethods,
        components: {
            ssrManageAdd,
            proposalPane,
            spmCorePane
        },
        data() {
            return {
                ssr: {
                    supplierCode: '',
                    supplierName: '',
                    address: '',
                },
                currentTab: 'baseInfoPane',
                labelPosition: 'right',
            }
        },
        created() {
        },
        computed: {
            showCopyToNewRound() {
                let that = this;
                return function (round) {
                    if (that.ssr.ssrRounds.length <= 1) {
                        return false;
                    } else if(that.ssr.status == "ISSUED" && round.roundNumber < that.ssr.currentRound){
                        return true;
                    }
                    return false;
                }
            },
            toRomanNum() {
                return function (num) {
                    return commonFun.toRomanNum(num);
                }
            },
            isRecommendation() {
                try {
                    let rounds = this.ssr.ssrRounds;
                    let lastRound = rounds[rounds.length - 1];
                    let ssrRoundSupplier = lastRound.ssrRoundSuppliers.filter(sup=>{sup.tmSupplierId == JSON.parse(localStorage.getItem("supplierObj")).tmSupplierId})[0];
                    return commonFun.isNotEmpty(ssrRoundSupplier) && ssrRoundSupplier.status == "AWARD"
                } catch (e) {
                    console.info(e);
                    return false;
                }
            }
        },
        methods: {
            copyToNewRound(round) {
                let ssrRounds = this.ssr.ssrRounds;
                if (ssrRounds.length > 1) {
                    let lastRound = ssrRounds[ssrRounds.length - 1];
                    var ssrRoundSupplierPqcps = JSON.parse(JSON.stringify(round.ssrRoundSupplierPqcps));
                    var ssrRoundSupplierPcns = JSON.parse(JSON.stringify(round.ssrRoundSupplierPcns));
                    var costBreakdownTemplate = JSON.parse(JSON.stringify(round.costBreakdownTemplate));
                    var ssrRoundSupplierCosts = JSON.parse(JSON.stringify(round.ssrRoundSupplierCosts));
                    var costBreakdownFiles = JSON.parse(JSON.stringify(round.costBreakdownFiles));
                    var supplierCapacityFiles = JSON.parse(JSON.stringify(round.supplierCapacityFiles));
                    var otherFormat = JSON.parse(JSON.stringify(round.ssrRoundSuppliers[0].otherFormat));
                    var proposalDocs = JSON.parse(JSON.stringify(round.ssrRoundSuppliers[0].proposalDocs));
                    [costBreakdownFiles, supplierCapacityFiles, otherFormat, proposalDocs].forEach(files=>{
                        if (commonFun.isNotEmpty(files)) {
                            files.forEach(file => file.tmDocumentId = null);
                        }
                    })
                    round.ssrRoundSupplierCapacities.forEach(capacity=>{
                        capacity.ttCapacityId = null;
                        if (capacity.data != null && capacity.data.capacityFiles != null) {
                            capacity.data.capacityFiles.forEach(doc=>{
                                doc.tmDocumentId = null;
                            });
                        }
                    })
                    var ssrRoundSupplierCapacities = JSON.parse(JSON.stringify(round.ssrRoundSupplierCapacities));
                    var ssrRoundSupplierLogistics = JSON.parse(JSON.stringify(round.ssrRoundSupplierLogistics));

                    if (ssrRoundSupplierPqcps.length > 0  && this.ssr.needPqcp == 'Y') {
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "ssrRoundSupplierPqcps", ssrRoundSupplierPqcps);
                    }
                    if (ssrRoundSupplierPcns.length > 0 && this.ssr.needPcn == 'Y') {
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "ssrRoundSupplierPcns", ssrRoundSupplierPcns);
                    }
                    if ((ssrRoundSupplierCosts.length > 0 || costBreakdownFiles.length > 0) && this.ssr.needCostBreakdown == "Y") {
                        if (costBreakdownTemplate.length == lastRound.costBreakdownTemplate.length) {
                            this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "ssrRoundSupplierCosts", ssrRoundSupplierCosts);
                        }
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "costBreakdownFiles", costBreakdownFiles);
                    }
                    if ((ssrRoundSupplierCapacities.length > 0 || supplierCapacityFiles.length >0) && this.ssr.needCapacityAnalysis== "Y") {
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "ssrRoundSupplierCapacities", ssrRoundSupplierCapacities);
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "supplierCapacityFiles", supplierCapacityFiles);
                    }
                    if (ssrRoundSupplierLogistics.length > 0 && this.ssr.needLogisticCapacity== "Y") {
                        this.$set(this.ssr.ssrRounds[ssrRounds.length - 1], "ssrRoundSupplierLogistics", ssrRoundSupplierLogistics);
                    }
                    this.$set(this.ssr.ssrRounds[ssrRounds.length - 1].ssrRoundSuppliers[0], "proposalDocs", proposalDocs);
                    this.$set(this.ssr.ssrRounds[ssrRounds.length - 1].ssrRoundSuppliers[0], "otherFormat", otherFormat);
                    this.$set(this.ssr.ssrRounds[ssrRounds.length - 1].ssrRoundSuppliers[0], "proposalRemark", round.ssrRoundSuppliers[0].proposalRemark);
                    this.currentTab = 'round' + ssrRounds.length;
                }
            },
            accept(accept) {
                let that = this;
                let remarksPromise= null;
                if (!accept) {
                    remarksPromise = this.prompt('Remark', this.$t("ssrManage.refuseRemark"), null, null, {
                        inputValidator: (val) => {
                            if (commonFun.isEmpty(val)) {
                                return 'Can not be empty!'
                            }
                            return val.length < 301
                        },
                        inputErrorMessage: that.$t("sensory.report.reasonTooLong")
                    }).then();
                } else {
                    remarksPromise = new Promise(resolve => resolve({}));
                }
                remarksPromise.then(({value}) => {
                    let that = this;
                    apiService.supplierAccept({ttSsrId: that.ssr.ttSsrId, accept: accept, remarks: value}).then(res => {
                        if (res.code == 200) {
                            that.$store.dispatch("reload");
                        }
                    });
                });
            }
        }
    }
</script>
<style scoped>
</style>
